import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from './CTAButton';
import { PRICE } from './salesData';
import { trackInitiateCheckout } from '../utils/metaPixel';

/**
 * Barra de compra fija (mobile y desktop). Aparece una vez que el CTA del hero
 * quedó atrás y se oculta al llegar al footer para no tapar contenido.
 */
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const scrolledPastHero = window.scrollY > window.innerHeight * 0.8;
      const footer = document.getElementById('site-footer');
      const footerReached = footer ? footer.getBoundingClientRect().top <= window.innerHeight : false;
      setVisible(scrolledPastHero && !footerReached);
    };
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-stone bg-white/95 backdrop-blur transition-transform duration-300 ease-out ${visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'}`} style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-167" data-mp="2iemf39u6anxh">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 py-1.5 sm:py-2.5" data-id="element-168" data-mp="2x650jn5sxao8">
        <div className="min-w-0" data-id="element-169" data-mp="321k9q1sv6ieb">
          <p className="truncate font-display text-[0.58rem] font-bold uppercase tracking-[0.1em] text-taupe sm:text-[0.66rem]" data-id="element-170" data-mp="365a0mxx0hc2i">
            200 Fórmulas de Velas Artesanales
          </p>
          <div className="flex items-baseline gap-1.5" data-id="element-171" data-mp="1bqfsb4b4blgl">
            <p className="font-display text-[1.25rem] font-extrabold leading-none tracking-tight tabular-nums text-charcoal sm:text-[1.4rem]" data-id="element-172" data-mp="1bt1yazid1swp">
              {PRICE.current}
            </p>
            <p className="font-sans text-[0.68rem] tabular-nums text-taupe/70" style={{
            textDecoration: 'line-through'
          }} data-id="element-173" data-mp="2a4mp2kkryzt1">
              {PRICE.previous}
            </p>
          </div>
        </div>
        <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} tabIndex={visible ? 0 : -1} className="cta-gradient flex min-h-[46px] max-w-[11rem] shrink-0 items-center justify-center rounded-xl px-4 py-2 text-center font-display text-[0.7rem] font-bold uppercase leading-[1.15] tracking-[0.03em] text-white sm:px-5 sm:text-[0.78rem] shadow-[0_12px_26px_-12px_rgba(106,63,184,0.8)] transition-transform duration-200 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:max-w-none" data-id="element-174" data-mp="2y0h9i3d6f0zs">
          Quiero hacer velas que den ganancias
        </a>
      </div>
    </div>;
}